import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import PageHeader from "../components/pageHeader";

const PriceRequest =()=>{

    const [dataRequestList, setDataRequestList] = useState([]);

        // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/VisitorList/Get-GetVisitorsPriceRequestList', setDataRequestList);

    }, [dataRequestList]);

    const columns = [
        {
            name: "Artwork",
            cell: (row) => <img className="m-2" src={`../images/products/thumbnail/${row.imageURL}`} alt=" " width="80px" />,
            width: "110px"

        },
        {
            name: "Title",
            selector: row => (
                <>
                    {row.productTitle} <br/> ({row.productCode})
                </>
            ),
            width: "150px"
        },
        {
            name: "Visitor Name",
            selector: (row) => row.visitorName,
            width: "150px",
            wrap: true,
        },
        {
            name: "Visitor Email",
            selector: (row) => row.visitorEmail,
            width: "150px"
        },
        {
            name: "Mobile",
            selector: row => (
                <>
                    {row.visitorMobile}
                </>
            ),
            width: "150px"
        },
        {
            name: "Visitor Message",
            selector: (row) => row.visitorMessage,
            width: "150px"
        },
        {
            name: "Date",
            // selector: (row) => row.createdOn,
            selector: (row) => new Date(row.enquiryDate).toLocaleDateString('en-GB',{day: 'numeric', month: 'short', year: 'numeric'}),

        },
        {
            name: "Action",
            cell: (row) => <><button className="btn btn-light" onClick={() => onDeleteClick(row.id)}><i className="bi bi-trash3-fill"></i></button></>
        },
    ];

    const onDeleteClick = async (id) => {
        const confirmed = window.confirm("Are you sure you want to Delete Enquiry ?");
        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        try {
            const response = await fetch(`https://igapi.heuristticminds.com/api/VisitorList/Delete-DeleteVisitorsEnquiryData?id=` + id, {
                method: 'DELETE'
            });
            if (response.ok) {
                // Refresh cart data if deletion was successful
                const url = `https://igapi.heuristticminds.com/api/VisitorList/Get-GetVisitorsPriceRequestList`;
                fetchData(url, setDataRequestList);
            } else {
                // Server responded with an HTTP status code outside the range 200-299
                console.error('Failed to delete enquiry. Status:', response.status);
            }
        }
        catch (error) {

            console.error('Error saving form data:', error);
        }
        //bindgrid 
    };



    return(
        <div>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <div>
                        <PageHeader name='Price Request List' icon='bi bi-cart-fill' />
                        <div className="container-xl px-4">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="card mb-4 h-100">
                                        <div className="card-header">Visitor's Data (Price Request)</div>
                                        <div className="card-body">

                                        <div className="ps-2 pe-2">
                                                <DataTable
                                                    columns={columns}
                                                    data={dataRequestList}
                                                    pagination
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    )
};
export default PriceRequest